module.exports = __webpack_public_path__ + "img/artist--steve-newman--heart-tattoo_17136180502.jpg";